"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopsoilContract = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var TopsoilContract = (function (_super) {
    __extends(TopsoilContract, _super);
    function TopsoilContract() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.TOPSOIL_CONTRACT,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.EARTH],
            cost: 8,
            metadata: {
                cardNumber: 'X30',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you gain a microbe to ANY CARD, also gain 1 M€.', function (eb) {
                        eb.microbes(1).asterix().startEffect.megacredits(1);
                    }).br;
                    b.plants(3);
                }),
                description: 'Gain 3 plants.',
            },
        }) || this;
    }
    TopsoilContract.prototype.play = function (player) {
        player.plants += 3;
        return undefined;
    };
    return TopsoilContract;
}(Card_1.Card));
exports.TopsoilContract = TopsoilContract;
